module.exports = __webpack_public_path__ + "static/media/crud_perfil_update.5221e878.png";